import { LAYOUT_REGIONS, normalizeDockZone } from './constants.js';
import { normalizeZoneList } from './panelZoneConstraints.js';
import { allowedRootZonesList, resolveRootRegionFromHit } from './dockModel.js';

function toSet(list) {
    return new Set(Array.isArray(list) ? list : []);
}

function fromSet(set) {
    return [...set].filter((z) => LAYOUT_REGIONS.includes(z));
}

export function normalizeRootZonePolicy(policy = {}) {
    const allowedRaw =
        policy?.allowedZones !== undefined ? policy.allowedZones : policy?.allowed;
    const disallowedRaw =
        policy?.disallowedZones !== undefined
            ? policy.disallowedZones
            : policy?.disallowed;
    const allowed = normalizeZoneList(allowedRaw);
    const disallowed = allowed ? null : normalizeZoneList(disallowedRaw);
    return { allowed, disallowed };
}

export function mergeRootZonePolicies(parentPolicy = {}, ownPolicy = {}) {
    const parent = normalizeRootZonePolicy(parentPolicy);
    const own = normalizeRootZonePolicy(ownPolicy);
    let effective = toSet(allowedRootZonesList(parent.allowed, parent.disallowed));

    if (own.allowed?.length) {
        const ownAllowed = toSet(own.allowed);
        effective = new Set([...effective].filter((z) => ownAllowed.has(z)));
    } else if (own.disallowed?.length) {
        for (const z of own.disallowed) effective.delete(z);
    }

    return {
        allowed: fromSet(effective),
        disallowed: null,
    };
}

export function resolvePanelPolicy(def = {}) {
    const inherited = normalizeRootZonePolicy(def.inheritedZonePolicy || {});
    const own = normalizeRootZonePolicy(def);
    const merged = mergeRootZonePolicies(inherited, own);
    return {
        ...merged,
        allowedRootZones: merged.allowed,
    };
}

export function canDockPanelInRootRegion(panelId, rootRegion, registry = {}) {
    if (!panelId) return true;
    const reg = registry[panelId];
    if (!reg) return true;
    const normalizedRoot = normalizeDockZone(rootRegion);
    const resolved = reg.allowedRootZones?.length
        ? { allowed: reg.allowedRootZones, disallowed: null }
        : normalizeRootZonePolicy(reg);
    return allowedRootZonesList(resolved.allowed, resolved.disallowed).includes(
        normalizedRoot,
    );
}

export function canDockPanelAtRootAwareHit(panelId, hit, context = {}, registry = {}) {
    const rootRegion = resolveRootRegionFromHit(hit, context);
    return canDockPanelInRootRegion(panelId, rootRegion, registry);
}

export function canDockPanelsInRootRegion(panelIds, rootRegion, registry = {}) {
    if (!Array.isArray(panelIds) || !panelIds.length) return true;
    return panelIds.every((panelId) =>
        canDockPanelInRootRegion(panelId, rootRegion, registry),
    );
}

